import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { useCloseOnEscape } from '../../../hooks/useCloseOnEscape';
import occasiaMark from '../../icons/figma/home-mobile/occasia-mark.svg';
import menuIcon from '../../icons/figma/home-mobile/menu.svg';
import menuHomeIcon from '../../icons/figma/home-mobile/menu-home.svg';
import menuSettingsIcon from '../../icons/figma/home-mobile/menu-settings.svg';
import menuStarIcon from '../../icons/figma/home-mobile/menu-star.svg';
import menuMessageIcon from '../../icons/figma/home-mobile/menu-message.svg';
import menuLogoutIcon from '../../icons/figma/home-mobile/menu-logout.svg';
import menuCloseIcon from '../../icons/figma/home-mobile/menu-close.svg';
import './SettingsMobile.css';

const MENU_ITEMS = [
  { id: 'home', label: 'Home', icon: menuHomeIcon },
  { id: 'settings', label: 'Settings', icon: menuSettingsIcon },
  { id: 'feedback', label: 'Customer feedback', icon: menuStarIcon },
  { id: 'comms', label: 'Messages', icon: menuMessageIcon }
];

const VenueMobileHeader = ({ activeSection, onSectionChange, onBeforeOpen }) => {
  const { logout, isLoggingOut } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);
  useCloseOnEscape(menuOpen, closeMenu);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, [menuOpen]);

  const handleLogout = async () => {
    try {
      await logout();
    } finally {
      navigate('/');
    }
  };

  return (
    <div className="venue-mobile-header">
      <div className="settings-mobile-top">
        <img src={occasiaMark} alt="Occasia" width="24" height="24" />
        <button
          type="button"
          className="settings-mobile-icon"
          aria-label="Menu"
          aria-expanded={menuOpen}
          onClick={() => {
            onBeforeOpen?.();
            setMenuOpen(true);
          }}
        >
          <img src={menuIcon} alt="" width="20" height="20" />
        </button>
      </div>
      {menuOpen ? (
        <div className="settings-mobile-overlay settings-mobile-overlay--top" onClick={closeMenu}>
          <div
            className="settings-mobile-menu"
            role="dialog"
            aria-modal="true"
            aria-label="Menu"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="settings-mobile-menu-header">
              <img src={occasiaMark} alt="Occasia" width="24" height="24" />
              <button type="button" className="settings-mobile-icon" aria-label="Close" onClick={closeMenu}>
                <img src={menuCloseIcon} alt="" width="20" height="20" />
              </button>
            </div>
            {MENU_ITEMS.map((item) => (
              <button
                key={item.id}
                type="button"
                className="settings-mobile-menu-item"
                onClick={() => {
                  setMenuOpen(false);
                  if (item.id !== activeSection) onSectionChange?.(item.id);
                }}
              >
                <img src={item.icon} alt="" width="20" height="20" />
                <span>{item.label}</span>
              </button>
            ))}
            <button
              type="button"
              className="settings-mobile-menu-item settings-mobile-menu-item--logout"
              onClick={handleLogout}
              disabled={isLoggingOut}
            >
              <img src={menuLogoutIcon} alt="" width="20" height="20" />
              <span>{isLoggingOut ? 'Signing out...' : 'Logout'}</span>
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default VenueMobileHeader;
